export default "__VITE_ASSET__b7a166e5__"